import { render, staticRenderFns } from "./UserAddressPage.vue?vue&type=template&id=fbf18d96&"
import script from "./UserAddressPage.vue?vue&type=script&lang=js&"
export * from "./UserAddressPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports